<template>
  <barcode :value="this.id_card" format="CODE128" displayValue="false" textAlign="center" height="70"></barcode>
</template>

<script>
import VueBarcode from 'vue-barcode'

export default {
  name: 'barcodeView',
  props: ['id_card'],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {}
  },
  created() {
    // console.log(this.id_card)
  },
  mounted() {
    // console.log(this.id_card)
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/barcodeView.vue